"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import {
  Component,
  Mixins
} from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import DateFormat from "@/framework/timeformatter";
let VirtualDesktopTrafficDetail = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    this.vdId = "";
    this.searchIp = "";
    this.gridController = new GridController(
      new APIDataSource(`api://base.auth/api/v8/ip_traffic_logs`)
    );
  }
  mounted() {
    return __async(this, null, function* () {
      this.gridController.pagePosition = "dialog";
      this.gridController.query.sort = "createdTime,desc";
      yield this.gridController.search();
    });
  }
  getTrafficDetail() {
    return __async(this, null, function* () {
      try {
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  searchByIP(ip) {
    return __async(this, null, function* () {
      if (ip === null || ip === void 0 || ip === "") {
        this.gridController.query.params = null;
        this.gridController.query.sort = "createdTime,desc";
        this.gridController.query.current = 1;
        yield this.gridController.search();
      } else {
        this.gridController.query.params = {
          search: {
            ip
          }
        };
        this.gridController.query.sort = "createdTime,desc";
        this.gridController.query.current = 1;
        yield this.gridController.search();
      }
    });
  }
  checkUnit(unit) {
    if (unit === "HOUR") {
      return this.$t("traffic_detail.hour");
    }
    if (unit === "DAY") {
      return this.$t("traffic_detail.day");
    }
    if (unit === "MONTH") {
      return this.$t("traffic_detail.month");
    }
    if (unit === "WEEK") {
      return this.$t("traffic_detail.week");
    }
    return "";
  }
  format_time(time) {
    if (time === 0 || time === null || time === void 0) {
      return "--";
    }
    return DateFormat.dateformat(DateFormat.check(time));
  }
  goBack() {
    this.$router.go(-1);
  }
};
VirtualDesktopTrafficDetail = __decorateClass([
  Component({
    components: {
      UiGrid
    }
  })
], VirtualDesktopTrafficDetail);
export {
  VirtualDesktopTrafficDetail as default
};
